"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
const l = ({
  title: i,
  titleId: r,
  desc: n,
  descId: s,
  ...o
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": s,
    ...o,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: s, children: n }) : null,
      i ? /* @__PURE__ */ e("title", { id: r, children: i }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m22 10.5-.4744-3.7954c-.1861-1.4886-.2791-2.233-.6295-2.7938A3 3 0 0 0 19.613 2.778c-.6-.278-1.3501-.278-2.8504-.278H7.2374c-1.5003 0-2.2504 0-2.8504.278A3 3 0 0 0 3.104 3.9108c-.3504.5609-.4434 1.3052-.6295 2.7938L2 10.5m3.5 4h13m-13 0C3.567 14.5 2 12.933 2 11s1.567-3.5 3.5-3.5h13c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5m-13 0C3.567 14.5 2 16.067 2 18s1.567 3.5 3.5 3.5h13c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5M6 11h.01M6 18h.01M12 11h6m-6 7h6"
        }
      )
    ]
  }
);
export {
  l as default
};
